import { Spin } from "antd";
import React from "react";

function CustomLoader({ tipText = "Loading..." }) {
    return (
        <div style={{
            position: "fixed",
            top: 0,
            left: 0,
            zIndex: 1000,
            background: "#ffffff8f",
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        }}>
            <Spin style={{ fontWeight: 'bold' }} tip={tipText} size="large" />
        </div>
    );
}

export default CustomLoader;
